var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right publish-sign" },
    [
      _c(
        "div",
        { staticClass: "upload-file" },
        [
          this.$store.getters.authUser.identityAuth > -1
            ? [
                _c(
                  "div",
                  {
                    staticClass: "sign_color",
                    attrs: { size: _vm.size, type: "primary" },
                    on: { click: _vm.toFile }
                  },
                  [
                    _c("img", {
                      staticClass: "hover_add_img",
                      attrs: {
                        src: require("../../static/images/home/add.png"),
                        alt: ""
                      }
                    }),
                    _c("img", {
                      staticClass: "add_img",
                      attrs: {
                        src: require("../../static/images/home/add_red.png"),
                        alt: ""
                      }
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.fileText))])
                  ]
                )
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass: "sign_color",
                    attrs: { size: _vm.size, type: "primary" },
                    on: { click: _vm.authFn }
                  },
                  [
                    _c("img", {
                      staticClass: "hover_add_img",
                      attrs: {
                        src: require("../../static/images/home/add.png"),
                        alt: ""
                      }
                    }),
                    _c("img", {
                      staticClass: "add_img",
                      attrs: {
                        src: require("../../static/images/home/add_red.png"),
                        alt: ""
                      }
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.fileText))])
                  ]
                )
              ]
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.authDialog, title: "实名认证", width: "475px" },
          on: {
            "update:visible": function($event) {
              _vm.authDialog = $event
            }
          }
        },
        [
          _c("p", { staticClass: "authDialog" }, [
            _c("img", {
              attrs: { src: require("../../static/images/warning.png") }
            }),
            _vm._v("您还未完成实名认证，认证后才能执行该操作。\n    ")
          ]),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: {
                    border: "none",
                    background: "#ec1c1c",
                    color: "#ffffff"
                  },
                  attrs: { size: "small" },
                  on: { click: _vm.gotoAuth }
                },
                [_vm._v("去认证")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94270134", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94270134","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/publish-sign/sign.vue
// module id = e65H
// module chunks = 23 24